import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: '/v2',
    routes: [
        {
            path: "/",
            redirect: "/dashboard",
            component: () => import("@/view/layout/Layout"),
            children: [
                {
                    path: "/dashboard:section?",
                    name: "dashboard",

                    component: () => import("@/view/pages/Dashboard/Dashboard.vue"),
                    meta: { title: "Dashboard" },
                },
                {
                    path: "/builder/:workflowid?",
                    name: "builder",
                    component: () => import("@/view/pages/Builder/Builder.vue"),
                    meta: { title: "Builder" },
                },                
                {
                    path: "/mydatasources",
                    name: "mydatasources",
                    component: () => import("@/view/pages/Datasources/MyDataSources.vue"),
                    meta: { title: "My DataSources" },
                },
                {
                    path: '/systemalerts/:systemalertid?',
                    name: "systemalerts",
                    component: () => import("@/view/pages/SystemAlerts/SystemAlerts.vue"),
                    meta: { title: 'System Alerts' }
                },
                {
                    path: '/usercredits',
                    name: "usercredits",
                    component: () => import("@/view/pages/User/UserCredits.vue"),
                    meta: { title: 'Credit Management' }
                },
                {
                    path: '/audithistory',
                    name: "audithistory",
                    component: () => import("@/view/pages/Audit/ViewAuditHistory.vue"),
                    meta: { title: 'Audit History' }
                },
                {
                    path: '/compareaudithistory',
                    name: "compareaudithistory",
                    component: () => import("@/view/pages/Audit/CompareAuditHistory.vue"),
                    meta: { title: 'Compare Audit History' }
                },
                {
                    path: '/batchrefresh',
                    name: "batchrefresh",
                    component: () => import("@/view/pages/BatchRefresh/ViewBatchRefresh.vue"),
                    meta: { title: 'Batch Refresh' }
                },
                {
                    path: "/admindash",
                    name: "admindash",
                    component: () => import("@/view/pages/AdminDash/AdminDash.vue"),
                    meta: { title: 'Admin Dashboard' }
                },
                {
                    path: "/oauth/concur/:id?:requestToken?:userId?:appIdentifier?",
                    name: "oauthconcur",
                    component: () => import("@/view/pages/OAuth/Concur/Accept.vue"),
                    meta: { title: "Oauth Concur" }
                },
                {
                    path: "/toolbox/services/:id?",
                    name: "toolboxservices",
                    component: () => import("@/view/pages/Toolbox/Services/Services.vue"),
                    meta: { title: "Toolbox Services" }
                },
                {
                    path: "/toolbox/transformers",
                    name: "transformers",
                    component: () => import("@/view/pages/Toolbox/Transformers.vue"),
                    meta: { title: "Transformers" }
                },
                {
                    path: "/toolbox/jstransforms/:workflowId?/:serviceId?/:workflowTransactionId?",
                    name: "jstransforms",
                    component: () => import("@/view/pages/Toolbox/JSTransforms.vue"),
                     meta: { title: "Javascript & Liquid Transformation Playground" }
                }, 
                {
                    path: "/toolbox/mappingdoc/:workflowId?/:itemName?/:isProduct?",
                    name: "mappingdoc",
                    component: () => import("@/view/pages/Toolbox/MapDocEditor.vue"),
                    meta: { title: "Mapping Document Editor" },
                    props: true
                },
                {
                    path: "/guide",
                    name: "guide",
                    component: () => import("@/view/pages/Guide/StyleGuide.vue"),
                    meta: { title: "Component and Style Guide" }
                },
                {
                    path: "/wip",
                    name: "wip",
                    component: () => import("@/view/pages/WIP/WIP.vue"),
                    meta: { title: 'WIP' }
                },
                {
                    path: "/buttertest",
                    name: "buttertest",
                    component: () => import("@/view/pages/WIP/ButterTest.vue"),
                    meta: { title: 'Butter Test' }
                },
                {
                    path: "/convertdatasources",
                    name: "convertdatasources",
                    component: () => import("@/view/pages/WIP/ConvertDatasources.vue"),
                    meta: { title: 'Convert Datasources' }
                },
                {
                    path: "/importexporttool",
                    name: "importexporttool",
                    component: () => import("@/view/pages/Tools/ImportExportTool.vue"),
                    meta: { title: 'Import Export Tool' }
                },
                {
                    path: "/concurauthmigrate",
                    name: "concurauthmigrate",
                    component: () => import("@/view/pages/Tools/ConcurAuthMigrate.vue"),
                    meta: { title: 'Concur Auth Migration' }
                },
                {
                    path: "/instanceadmin",
                    name: "instanceadmin",
                    component: () => import("@/view/pages/Tools/InstanceAdmin.vue"),
                    meta: { title: 'Instance Admin' }
                },
                {
                    path: "/renameproduct/:productId",
                    name: "renameproduct",
                    component: () => import("@/view/pages/Tools/RenameProduct.vue"),
                    meta: { title: 'Rename Product' }
                },
                {
                    path: "/dbadmin",
                    name: "dbadmin",
                    component: () => import("@/view/pages/Tools/DBAdmin.vue"),
                    meta: { title: 'DB Admin' }
                },
                {
                    path: "/workflowreport",
                    name: "workflowreport",
                    component: () => import("@/view/pages/Tools/WorkflowCallValidatorReport.vue"),
                    meta: { title: 'Workflow Report' }
                },
                {
                    path: "/FileToBase64StringToBlob",
                    name: "FileToBase64StringToBlob",
                    component: () => import("@/view/pages/WIP/FileToBase64StringToBlob.vue"),
                    meta: { title: 'File To Base64 String To Blob Storage' }
                },
                {
                    path: "/documentsync/:productid?/:docid?",
                    name: "documentsync",
                    component: () => import("@/view/pages/Tools/DocumentSync.vue"),
                    meta: { title: 'Document Sync' }
                },
                {
                    path: "/scheduler",
                    name: "scheduler",
                    component: () => import("@/view/pages/Scheduler/Scheduler.vue"),
                    meta: { title: 'Scheduler' }
                },
                {
                    path: "/workflowjobsbyuser/:userid?",
                    name: "workflowjobsbyuser",
                    component: () => import("@/view/pages/Scheduler/WorkflowJobsByUser.vue"),
                    meta: { title: 'Workflow Jobs by User' }
                },
                {
                    path: "/workflowjob/:workflowid",
                    name: "workflowjob",
                    component: () => import("@/view/pages/Scheduler/WorkflowJob.vue"),
                    meta: { title: 'Workflow Job' }
                },
                {
                    path: "/dynamicdocuments",
                    name: "dynamicdocuments",
                    component: () => import("@/view/pages/WIP/DynamicDocuments.vue"),
                    meta: { title: 'Dynamic Documents' }
                },
                {
                    path: "/webhooks/:webhookid?",
                    name: "webhooks",
                    component: () => import("@/view/pages/Webhooks/Webhooks.vue"),
                    meta: { title: 'Webhooks' }
                },
                {
                    path: "/allwebhooklogs",
                    name: "allwebhooklogs",
                    component: () => import("@/view/pages/Webhooks/AllWebhookLogs.vue"),
                    meta: { title: 'All webhook logs' }
                },
                //{
                //    path: "/documentsyncdiff/:docid",
                //    name: "documentsyncdiff",
                //    component: () => import("@/view/pages/Tools/DocumentSyncDiff.vue"),
                //    meta: { title: 'Document Sync Diff' }
                //},
                {
                    path: "/pages/:slug",
                    name: "cmspage",
                    component: () => import("@/view/pages/Pages/CMS.vue"),
                    //meta: { title: 'Pages' }
                },
                //path: "/builder",
                //{
                //  path: "/vue-bootstrap",
                //  name: "vue-bootstrap",
                //  component: () =>
                //    import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
                //  children: [
                //    {
                //      path: "alert",
                //      name: "vue-bootstrap-alert",
                //      component: () => import("@/view/pages/vue-bootstrap/Alert.vue")
                //    },
                //    {
                //      path: "badge",
                //      name: "vue-bootstrap-badge",
                //      component: () => import("@/view/pages/vue-bootstrap/Badge.vue")
                //    }            
                //  ]
                //}       
            ],
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: "/login",
            name: "login",
            beforeEnter() {
                var fullUrl = window.location.href;
                var origin = window.location.origin;
                //https://stackoverflow.com/questions/373599/how-to-pass-special-characters-so-asp-net-mvc-can-handle-correctly-query-string
                let returnUrl = "/User/Login?fromVue=true&ReturnUrl=" + encodeURI(fullUrl.replace(origin, "").replace("#", "VueHash"));
                window.location.href = returnUrl;
            }
        },
        {
            path: "/logoff",
            name: "logoff",
            beforeEnter() {
                window.location.href = "/User/LogOff";
            },
        },
        {
            path: "*",
            redirect: "/404",
        },
        {
            // the 404 route, when none of the above matches
            path: "/404",
            name: "404",
            meta: { title: 'NotFound' },
            component: () => import("@/view/pages/error/Error-1.vue")
        }
    ]    
});
